import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import BackToTop from "./components/BackToTop";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Unsubscribe from "./pages/Unsubscribe";
import Privacy from "./pages/Privacy";
import Home from "./pages/Home";
import GameDetail from "./pages/GameDetail";
import Terms from "./pages/Terms";

function App() {
    return (
        <Router>
            <ScrollToTop />
            <div className="min-h-screen bg-gradient-to-b from-[#fefce8] via-[#fef9c3] to-[#fef08a] text-black">
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/game/:id" element={<GameDetail />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/unsubscribe" element={<Unsubscribe />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                </Routes>
                <Footer />
                <BackToTop />
            </div>
        </Router>
    );
}


export default App;
